import { ColumnTypes } from '../store/types';

export const bookingType: ColumnTypes[] = [
  'defaulte',
  'vip-client',
  'groupe',
  'child-individual',
  'tournament'
];
export const bookingTypeColor = [
  'rgba(224, 161, 0, 0.5)', // с депозитом
  '#DE8FFF', // vip-client - фиолетовый
  'rgba(0, 181, 75, 0.5)', // groupe
  'rgba(0, 66, 198, 0.5)', // child-individual
  '#E0E0E0', // tournament - серый
  'rgba(220, 20, 60)' // без депозита
];
//#F6D79D
